import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import { IContentBlock, ContentBlockType } from "../../sdk/types/api";

export interface ICreateBlockMutationParameters {
    productId: string;
    variantId: string;
    type: ContentBlockType;
    properties: Record<string, unknown>;
    parentId?: string;
    afterId?: string | null;
}

export const useCreateBlock = (
    invalidQueryKeys: string | string[],
): UseMutationResult<IContentBlock, unknown, ICreateBlockMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IContentBlock, unknown, ICreateBlockMutationParameters>({
        mutationFn: async (parameters: ICreateBlockMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot create block without authorization token.");
            }

            const { productId, variantId, ...body } = parameters;

            return await api.Products.createBlock(productId, variantId, body, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
